import React from 'react'
import Button from './Button'
import styles from './Tags.module.css'
import Tag from './Tag'

function Tags({ tags, setTags } : { tags: string[], setTags: (value: (prev: string[]) => string[]) => void}) {
  const [tagInput, setTagInput] = React.useState('')

  function onAddTag() {
    if (tagInput) {
      setTags((prev) => [...prev, tagInput.toLowerCase()])
      setTagInput('')
    }
  }

  function onRemoveTag(tagName: string) {
    setTags((prev) => prev.filter((t: string) => t !== tagName))
  }

  return (
    <div>
      {tags && tags.length > 0 ? (
        <ul className={styles.tags}>
          {tags.map((tag: string, index: number) => (
            <li key={index}>
              <Tag name={tag} onRemoveTag={onRemoveTag} />
            </li>
          ))}
        </ul>
      ) : null}
      <div className={styles.tagInput}>
        <input
          className={styles.input}
          type="text"
          placeholder="Ange tagg"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
        />
        <Button size='small' color='pink' onClick={onAddTag}>Lägg till</Button>
      </div>
    </div>
  )
}

export default Tags
